import { Link, NavLink, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X, ShoppingBag } from "lucide-react";
import { useCart } from "@/contexts/CartContext";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_a1668682-6cd0-4608-a6a8-d20136862eb0/artifacts/fhi5ktps_IMG_9483.jpeg";

const NAV = [
  { to: "/", label: "Anasayfa" },
  { to: "/urunler", label: "Ürünler" },
  { to: "/kalite-karsilastirma", label: "Kalite Karşılaştırma" },
  { to: "/hakkimizda", label: "Hakkımızda" },
  { to: "/blog", label: "Blog" },
  { to: "/iletisim", label: "İletişim" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();
  const { count } = useCart();

  useEffect(() => { setOpen(false); }, [loc.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-2xl bg-[#030f26]/85 border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="wb-container flex items-center justify-between py-4">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img
            src={LOGO_URL}
            alt="Wünberg"
            className="w-11 h-11 object-cover border border-white/10 group-hover:border-[#d4af37]/60 transition-colors"
          />
          <div className="hidden sm:block leading-tight">
            <div className="font-serif text-lg font-medium tracking-wide">Wünberg</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#d4af37]">Paint &amp; Coating</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              data-testid={`nav-link-${it.to.replace(/\//g, "") || "home"}`}
              className={({ isActive }) =>
                `wb-link ${isActive ? "wb-link-active" : ""}`
              }
              end={it.to === "/"}
            >
              {it.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link to="/sepet" className="relative wb-link flex items-center gap-2" data-testid="nav-cart">
            <ShoppingBag size={18} />
            {count > 0 && (
              <span className="absolute -top-2 -right-3 bg-[#d4af37] text-[#030f26] text-[10px] font-bold w-5 h-5 flex items-center justify-center">
                {count}
              </span>
            )}
          </Link>
          <Link to="/bayi-girisi" className="wb-link" data-testid="nav-dealer-login">
            Bayi Girişi
          </Link>
          <Link to="/bayi-basvuru" className="wb-btn-primary !py-2.5 !px-5 text-sm" data-testid="nav-dealer-apply">
            Bayi Ol
          </Link>
        </div>

        <div className="lg:hidden flex items-center gap-2">
          <Link to="/sepet" className="relative p-2 border border-white/10" data-testid="mobile-cart">
            <ShoppingBag size={18} />
            {count > 0 && (
              <span className="absolute -top-1 -right-1 bg-[#d4af37] text-[#030f26] text-[10px] font-bold w-4 h-4 flex items-center justify-center">
                {count}
              </span>
            )}
          </Link>
          <button
            aria-label="menu"
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((v) => !v)}
            className="p-2 border border-white/10 hover:border-[#d4af37]/60 transition-colors"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-[#030f26]/95 backdrop-blur-2xl">
          <div className="wb-container py-6 flex flex-col gap-4">
            {NAV.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                data-testid={`mobile-nav-${it.to.replace(/\//g, "") || "home"}`}
                className={({ isActive }) =>
                  `text-base py-2 ${isActive ? "text-[#d4af37]" : "text-white/90"}`
                }
                end={it.to === "/"}
              >
                {it.label}
              </NavLink>
            ))}
            <div className="h-px bg-white/10 my-2" />
            <Link to="/bayi-girisi" className="wb-link" data-testid="mobile-dealer-login">Bayi Girişi</Link>
            <Link to="/bayi-basvuru" className="wb-btn-primary !py-3 text-sm" data-testid="mobile-dealer-apply">
              Bayi Ol
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
